(() => {
  let rewardsTimer;

  function findFixedRewardsControl() {
    const candidates = document.querySelectorAll('button, a, [role="button"]');

    for (const element of candidates) {
      if ((element.textContent || '').trim() !== 'Rewards') continue;
      if (element.closest('.uw-cart-sticky-checkout')) continue;

      let target = element;
      let current = element;

      for (let depth = 0; depth < 5 && current && current !== document.body; depth += 1) {
        const position = window.getComputedStyle(current).position;
        if (position === 'fixed' || position === 'sticky') {
          target = current;
          break;
        }
        current = current.parentElement;
      }

      const targetPosition = window.getComputedStyle(target).position;
      if (targetPosition === 'fixed' || targetPosition === 'sticky') {
        target.classList.add('uw-cart-rewards-minimized');
      }
    }
  }

  function scheduleRewardsAdjustment() {
    window.clearTimeout(rewardsTimer);
    rewardsTimer = window.setTimeout(findFixedRewardsControl, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRewardsAdjustment, { once: true });
  } else {
    scheduleRewardsAdjustment();
  }

  window.addEventListener('load', scheduleRewardsAdjustment, { once: true });

  const observer = new MutationObserver(scheduleRewardsAdjustment);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  window.setTimeout(() => observer.disconnect(), 12000);
})();
